import { FormEvent, ReactNode, useState } from 'react'
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { forgotPassword } from '../api/Auth';

function ForgotPassword(): ReactNode {
    const { t } = useTranslation(['forgot_pass', 'base']);

    const [errorInfo, setErrorInfo] = useState<ReactNode>(<div></div>);
    const [enabledButton, setEnabledButton] = useState<boolean>(true);
    const [emailValue, setEmailValue] = useState<string>("");

    function submitForm(event: FormEvent<HTMLFormElement>): void {
        event.preventDefault();
        setEnabledButton(false);

        // Сервер отвечает 204 на любой адрес, чтобы по ответу нельзя было
        // узнать, зарегистрирован ли он. Сообщение об успехе тоже нейтральное.
        forgotPassword({ email: emailValue.trim() }).then(() => {
            setErrorInfo(<div style={{ paddingTop: "10px" }}>{t('success')}</div>);
            setEnabledButton(true);
        }).catch(() => {
            setErrorInfo(<div style={{ color: "red", paddingTop: "10px" }}>{t('error')}</div>);
            setEnabledButton(true);
        });
    }

    return (
        <div className='form-page'>
            <div className='form-page-container'>
                <Form onSubmit={submitForm}>
                    <Form.Group className="login-form" controlId="formForgotPasswordEmail">
                        <Form.Label>{t('address')}</Form.Label>
                        <Form.Control
                            type="email"
                            required
                            autoComplete="email"
                            placeholder={t('address_placeholder')}
                            value={emailValue}
                            onChange={e => setEmailValue(e.currentTarget.value)}
                        />
                        <Form.Text className="text-muted" />
                    </Form.Group>
                    <Button variant="primary" type="submit" disabled={!enabledButton}>
                        {t('submit_button_text')}
                    </Button>
                </Form>
                {errorInfo}
            </div>
        </div>
    )
}

export default ForgotPassword;
